import { Pipe, PipeTransform } from '@angular/core';

/**
 * Capitaliza la primera letra de cada palabra y pasa el resto a minúsculas.
 * Útil para textos que vienen en MAYÚSCULAS desde el backend
 * y querés mostrar tipo "Medicamentos" en lugar de "MEDICAMENTOS".
 *
 * Ejemplos:
 *   "MEDICAMENTOS"   -> "Medicamentos"
 *   "ENFERMEDAD"     -> "Enfermedad"
 *   "asistencia 24/7" -> "Asistencia 24/7"
 *   ""               -> ""
 *   null/undefined   -> ""
 */
@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    return value
      .toString()
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
